import { writeSliceModel, upsertGlobalTypeScriptTypes, writeSliceFile } from "@prismicio/plugin-kit/fs";
import { stripIndent } from "common-tags";
import { checkIsTypeScriptProject } from "../lib/checkIsTypeScriptProject.js";
import { pascalCase } from "../lib/pascalCase.js";
import { rejectIfNecessary } from "../lib/rejectIfNecessary.js";
import { upsertSliceLibraryIndexFile } from "../lib/upsertSliceLibraryIndexFile.js";
var __freeze = Object.freeze;
var __defProp = Object.defineProperty;
var __template = (cooked, raw) => __freeze(__defProp(cooked, "raw", { value: __freeze(raw || cooked.slice()) }));
var _a, _b;
const createComponentFile = async ({ data, helpers, actions, options }) => {
  const pascalName = pascalCase(data.model.name);
  let contents;
  const isTypeScriptProject = await checkIsTypeScriptProject({
    helpers,
    options
  });
  const placeholderInstructions = `
		<br />
		<strong>You can edit this slice directly in your code editor.</strong>
		<!--
			💡 Use the Prismic MCP server with your code editor
			📚 Docs: https://prismic.io/docs/ai#code-with-prismics-mcp-server
		-->`;
  if (data.componentContents) {
    contents = data.componentContents;
  } else if (isTypeScriptProject) {
    contents = stripIndent(_a || (_a = __template(['\n			<script setup lang="ts">\n			import type { Content } from "@prismicio/client";\n\n			// The array passed to `getSliceComponentProps` is purely optional.\n			// Consider it as a visual hint for you when templating your slice.\n			defineProps(getSliceComponentProps<Content.', 'Slice>(\n				["slice", "index", "slices", "context"]\n			));\n			<\/script>\n\n			<template>\n				<section\n					:data-slice-type="slice.slice_type"\n					:data-slice-variation="slice.variation"\n				>\n					Placeholder component for ', " (variation: {{ slice.variation }}) slices.\n					", "\n				</section>\n			</template>\n		"], ['\n			<script setup lang="ts">\n			import type { Content } from "@prismicio/client";\n\n			// The array passed to \\`getSliceComponentProps\\` is purely optional.\n			// Consider it as a visual hint for you when templating your slice.\n			defineProps(getSliceComponentProps<Content.', 'Slice>(\n				["slice", "index", "slices", "context"]\n			));\n			<\/script>\n\n			<template>\n				<section\n					:data-slice-type="slice.slice_type"\n					:data-slice-variation="slice.variation"\n				>\n					Placeholder component for ', " (variation: {{ slice.variation }}) slices.\n					", "\n				</section>\n			</template>\n		"])), pascalName, data.model.id, placeholderInstructions);
  } else {
    contents = stripIndent(_b || (_b = __template(['\n			<script setup>\n			// The array passed to `getSliceComponentProps` is purely optional.\n			// Consider it as a visual hint for you when templating your slice.\n			defineProps(getSliceComponentProps(["slice", "index", "slices", "context"]));\n			<\/script>\n\n			<template>\n				<section\n					:data-slice-type="slice.slice_type"\n					:data-slice-variation="slice.variation"\n				>\n					Placeholder component for {{ model.id }} (variation: {{ slice.variation }}) slices.\n					', "\n				</section>\n			</template>\n		"], ['\n			<script setup>\n			// The array passed to \\`getSliceComponentProps\\` is purely optional.\n			// Consider it as a visual hint for you when templating your slice.\n			defineProps(getSliceComponentProps(["slice", "index", "slices", "context"]));\n			<\/script>\n\n			<template>\n				<section\n					:data-slice-type="slice.slice_type"\n					:data-slice-variation="slice.variation"\n				>\n					Placeholder component for {{ model.id }} (variation: {{ slice.variation }}) slices.\n					', "\n				</section>\n			</template>\n		"])), placeholderInstructions);
  }
  await writeSliceFile({
    libraryID: data.libraryID,
    model: data.model,
    filename: "index.vue",
    contents,
    format: options.format,
    actions,
    helpers
  });
};
const sliceCreate = async (data, context) => {
  rejectIfNecessary(await Promise.allSettled([
    writeSliceModel({
      libraryID: data.libraryID,
      model: data.model,
      format: context.options.format,
      helpers: context.helpers
    }),
    createComponentFile({ data, ...context })
  ]));
  rejectIfNecessary(await Promise.allSettled([
    upsertSliceLibraryIndexFile({
      libraryID: data.libraryID,
      ...context
    }),
    upsertGlobalTypeScriptTypes({
      filename: context.options.generatedTypesFilePath,
      format: context.options.format,
      helpers: context.helpers,
      actions: context.actions
    })
  ]));
};
export {
  sliceCreate
};
//# sourceMappingURL=slice-create.js.map
